import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
import axios from '../../hooks/fetchWithAuth';
import { useMediaQuery } from 'react-responsive';
import Modal from 'react-modal';
import { Box, Button, Avatar, IconButton, Typography, Divider } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from "@mui/icons-material/Add";
import { RiIdCardFill } from "react-icons/ri";
import { PiListDashesFill } from "react-icons/pi";
import { TfiClip } from "react-icons/tfi";
import { FaList } from "react-icons/fa";
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import EditableText from '../TextEditable';
import EditableTextField from '../EditableTextField';
import Etiquetas from '../Etiquetas';
import Members from '../Members';
import Checklist2 from '../Checklist2';
import Comments from '../Comments';
import ConfirmationDialog from '../Confirmation';
import { Span, Div, Flex } from "../../style";
import config from '../../config';
import SideMenu from '../SideMenu';
import './CardModal.css';
import getCookie from '../../hooks/getCookie';
import { getAvatarUrl } from '../../utils/getAvatarUrl';
import Checkbox from '@mui/material/Checkbox';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import ShareRoundedIcon from '@mui/icons-material/ShareRounded';
import Checklist from '../Checklist';
import CopyCard from '../CopyCard';
import Capa from '../Cover';
import Compartilhar from '../Compartilhar';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import DownloadIcon from '@mui/icons-material/Download';
import DescriptionIcon from '@mui/icons-material/Description';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import Alerts2 from '../Alert2';
import io from 'socket.io-client';
import NearMeIcon from '@mui/icons-material/NearMe';

function CardModal({ addCard, modalIsOpen, closeModal, selectedCard, cardDetails, comments, usersInCards, boardId, fetchTiBoardData, setSelectedCard, addUserToCardState, fetchLogs, fetchTagsInCards, handleSetSelectedTag, saveCardDetails, setCardDetails, setComments, logs, cardUrl, tagsInCards, fetchCoverColor, fetchCoverImage, coverImage, coverColor, fetchUsersInCards }) {
  const backendIp = config.backend_ip;
  const nameComplete = getCookie("nome_completo");
  const username = getCookie("username");
  const storedUserId = getCookie("userId");
  const sessionId = getCookie("session_id");
  const isSmallScreen = useMediaQuery({ query: '(max-width: 768px)' });
  const [openDetail, setOpenDetail] = useState('');
  const [anchorEl2, setAnchorEl2] = useState(null);
  const [detailAnchorEl, setDetailAnchorEl] = useState(null);
  const [attachments, setAttachments] = useState([]);
  const [selectedFileId, setSelectedFileId] = useState(null);
  const [dialogOpenAttachments, setDialogOpenAttachments] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [newComment, setNewComment] = useState('');
  const [items, setItems] = useState([]);
  const [newItem, setNewItem] = useState('');
  const [todos, setTodos] = useState(null);
  const [isUserAllowed, setIsUserAllowed] = useState(true);
  const [deleteCardDialogOpen, setDeleteCardDialogOpen] = useState(false);
  const [alert2, setAlert2] = React.useState(null);
  const [socket, setSocket] = useState(null);
  const [mousePositions, setMousePositions] = useState({});
  const [myColor] = useState('#' + Math.floor(Math.random() * 16777215).toString(16)); // random color for user
  const [lastMouseUpdate, setLastMouseUpdate] = useState({}); // { userId: timestamp }
  const joinedCardIdRef = useRef(null); // controla o card atualmente conectado

  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

  useEffect(() => {
    if (selectedCard) {
      fetchCoverColor();
      fetchCoverImage();
      fetchTagsInCards();
      listArchives(selectedCard.id).then(setAttachments);
      fetchLogs(selectedCard.id);
      fetchTasks();

      // Sincroniza o status de completed ao abrir o modal
      setCardDetails(prev => ({
        ...prev,
        completed: selectedCard.completed ?? false
      }));
    }
  }, [selectedCard]);

  useEffect(() => {
    if (username && boardId) {
      if (username === 'marcos' || username === 'sandro') {
        setIsUserAllowed(true);
      } else {
        const userBelongsToBoard = checkUserBelongsToBoard(storedUserId, boardId);
        setIsUserAllowed(userBelongsToBoard);
      }
    }
  }, [username, boardId]);

  useEffect(() => {
    // Conecta ao socket apenas uma vez
    if (!socket) {
      const socketUrl = config.socket_url;
      const socketPath = '/socket.io/';
      if (!socketUrl) return;
      const newSocket = io(socketUrl, {
        transports: ['websocket'],
        reconnection: true,
        path: socketPath,
        secure: true,
      });
      setSocket(newSocket);
      return () => {
        newSocket.disconnect();
      };
    }
  }, []);

  useEffect(() => {
    if (!socket || !selectedCard || !modalIsOpen) return;

    // Garante que só entra/sai da sala uma vez por card/modal
    if (joinedCardIdRef.current !== selectedCard.id) {
      // Sai da sala anterior se necessário
      if (joinedCardIdRef.current) {
        socket.emit('leave_card', { card_id: joinedCardIdRef.current });
        console.log('Saiu da sala do card:', joinedCardIdRef.current);
        // Limpa cursores imediatamente ao sair do card
        setMousePositions({});
        setLastMouseUpdate({});
      }
      // Entra na nova sala
      socket.emit('join_card', { card_id: selectedCard.id });
      console.log('Entrou na sala do card:', selectedCard.id);
      joinedCardIdRef.current = selectedCard.id;
    }

    // Eventos do socket
    socket.on('card_update', (data) => {
      // Atualiza o estado do card quando uma ação relevante de Checklist é recebida
      if (
        data.action === 'add_checklist' || // Adição de checklist
        data.action === 'add_task' || // Adição de tarefa
        data.action === 'edit_checklist' || // Edição de checklist
        data.action === 'delete_checklist' || // Exclusão de checklist
        data.action === 'edit_task' || // Edição de tarefa
        data.action === 'remove_task' || // Exclusão de tarefa
        data.action === 'update_task' || // Atualização de tarefa
        data.action === 'update_date_task' || // Exclusão de data de tarefa
        data.action === 'add_date' || // Atualização de data de tarefa
        data.action === 'add_subtask' || // Nova subtask adicionada
        data.action === 'edit_subtask' || // Edição de subtarefa
        data.action === 'remove_subtask'  // Remoção de subtarefa
      ) {
        handleChecklistUpdate();
      }

      // Atualiza os anexos quando arquivos são adicionados ou removidos
      if (
        data.action === 'add_file' || // Adição de arquivo
        data.action === 'remove_file' // Remoção de arquivo
      ) {
        listArchives(selectedCard.id).then(setAttachments);
      }

      // Atualiza a descrição do card
      if (
        data.action === 'update_description' // Atualização de descrição
      ) {
        fetchTiBoardData();
      }

      // Atualiza capa (cor ou imagem) em tempo real
      if (
        data.action === 'update_cover' || // Atualização de cor da capa
        data.action === 'remove_cover'    // Remoção de capa/imagem
      ) {
        fetchCoverColor();
        fetchCoverImage();
      }

      // Atualiza membros em tempo real
      if (
        data.action === 'add_members' ||
        data.action === 'remove_members'
      ) {
        fetchTiBoardData();
        if (typeof fetchUsersInCards === 'function') {
          fetchUsersInCards();
        }
      }

      // Atualiza etiquetas em tempo real
      if (data.action === 'set_tags' || data.action === 'remove_tags') {
        // Chama a função para buscar as etiquetas do card
        fetchTagsInCards();
      }

      // Atualiza o título do card em tempo real
      if (data.action === 'update_card_title') {
        setCardDetails(prev => ({
          ...prev,
          title: data.card_title
        }));
      }

      // Atualiza o status de conclusão do card em tempo real
      if (data.action === 'update_card_completed') {
        setCardDetails(prev => ({
          ...prev,
          completed: data.completed
        }));
      }

      // Atualiza comentários em tempo real
      if (
        data.action === 'add_comment' ||
        data.action === 'update_comment' ||
        data.action === 'remove_comment'
      ) {
        // Busca os comentários atualizados do card
        if (selectedCard && selectedCard.id) {
          axios.put(`${config.backend_ip}/api/board/ti/list_comments`, {
            card_id: selectedCard.id,
            session_id: getCookie("session_id"),
            user: getCookie("username")
          }).then(response => {
            setComments(response.data);
          });
        }
      }
    });

    return () => {
      // Sai da sala do card ao desmontar ou fechar modal
      if (joinedCardIdRef.current) {
        socket.emit('leave_card', { card_id: joinedCardIdRef.current });
        joinedCardIdRef.current = null;
        // Limpa cursores imediatamente ao sair do card/modal
        setMousePositions({});
        setLastMouseUpdate({});
      }
      socket.off('card_update');
    };
  // Dependências: socket, selectedCard, modalIsOpen, fetchCoverColor, fetchCoverImage, fetchTiBoardData, fetchUsersInCards, fetchTagsInCards
  }, [socket, selectedCard, modalIsOpen, fetchCoverColor, fetchCoverImage, fetchTiBoardData, fetchUsersInCards, fetchTagsInCards]);

  // Compartilha posição do mouse
  useEffect(() => {
    if (!socket || !selectedCard || !modalIsOpen) return;

    const user_id = getCookie("userId");
    const username = getCookie("username");

    const handleMouseMove = (e) => {
      const x = e.clientX;
      const y = e.clientY;
      socket.emit('mouse_position', {
        card_id: selectedCard.id,
        user_id,
        username,
        x,
        y,
        color: myColor,
        currentCardId: selectedCard.id
      });
      setLastMouseUpdate(prev => ({ ...prev, [user_id]: Date.now() }));
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      setMousePositions({});
      setLastMouseUpdate({});
      // Sai da sala do card ao fechar modal (já tratado no outro useEffect)
    };
  }, [socket, selectedCard, modalIsOpen, myColor]);

  // Escuta posições do mouse de outros usuários
  useEffect(() => {
    if (!socket || !selectedCard) return;

    socket.on('mouse_position', (data) => {
      // Sempre usa o username local do getCookie
      const usernameLocal = getCookie("username");
      setMousePositions(prev => ({
        ...prev,
        [data.user_id]: {
          x: data.x,
          y: data.y,
          color: data.color,
          username: data.username || usernameLocal,
          currentCardId: data.currentCardId
        }
      }));
      setLastMouseUpdate(prev => ({
        ...prev,
        [data.user_id]: Date.now()
      }));
    });

    return () => {
      socket.off('mouse_position');
    };
  }, [socket, selectedCard]);

  // Remove cursores de usuários inativos após 10 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      const now = Date.now();
      setMousePositions(prev => {
        const filtered = {};
        Object.entries(prev).forEach(([userId, pos]) => {
          if (lastMouseUpdate[userId] && now - lastMouseUpdate[userId] < 10000) {
            filtered[userId] = pos;
          }
        });
        return filtered;
      });
    }, 3000);
    return () => clearInterval(interval);
  }, [lastMouseUpdate]);

  // Renderiza cursores dos outros usuários com NearMeIcon e nome
  const renderMouseCursors = () => {
    // Só mostra cursores do mesmo cardId exato (não só valor igual)
    return Object.entries(mousePositions)
      .filter(([_, pos]) => String(pos.currentCardId) === String(selectedCard && selectedCard.id))
      .map(([userId, pos]) => (
        <div
          key={userId}
          style={{
            position: 'fixed',
            left: pos.x + 5,
            top: pos.y + 5,
            zIndex: 9999,
            pointerEvents: 'none',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <NearMeIcon
            style={{
              fontSize: 32,
              color: pos.color,
              transform: 'rotate(-75deg)'
            }}
          />
          <span
            style={{
              marginTop: 2,
              fontSize: 12,
              fontWeight: 600,
              color: pos.color,
              borderRadius: 4,
              padding: '1px 6px',
              maxWidth: 120,
              textAlign: 'center',
              whiteSpace: 'nowrap',
            }}
          >
            {pos.username || "Usuário"}
          </span>
        </div>
      ));
  };

  if (!isUserAllowed) {
    return <div>Você não tem permissão para acessar este quadro.</div>;
  }

  const checkUserBelongsToBoard = async (username, boardId) => {
    try {
      const response = await axios.post(`${backendIp}/api/board/ti/checkUserBelongsToBoard`, { session_id: sessionId, username, board_id: boardId });
      return response.data.belongsToBoard;
    } catch (error) {
      return false;
    }
  };

  const handleNewTodos = () => {
    setTodos(true);
  };

  const handleDelete = async (attachmentId) => {
    try {
      const response = await axios.put(`${backendIp}/api/board/ti/remove_archive`, {
        attachment_id: attachmentId,
        name_complete: nameComplete,
        user: username,
        session_id: sessionId
      });
      fetchLogs(selectedCard.id);

      setAttachments((prevAttachments) =>
        prevAttachments.filter((attachment) => attachment.file_id !== attachmentId)
      );
      setDialogOpenAttachments(false);
    } catch (error) {
      return [];
    }
  }

  const handleConfirmDelete = () => {
    if (selectedFileId !== null) {
      handleDelete(selectedFileId);
      setSelectedFileId(null);
      setDialogOpenAttachments(false);
    }
  };

  const handleItemClick = (event, item) => {
    setAnchorEl2(event.currentTarget);
    setOpenDetail(item);
  };

  const handleDetailClick = (event, detail) => {
    setDetailAnchorEl(event.currentTarget);
    setOpenDetail(detail);
  };

  const handleCloseDetail = () => {
    setOpenDetail('');
    setDetailAnchorEl(null);
  };

  const getBrightness = (hex) => {
    let r, g, b;
    if (hex.length === 4) {
      r = parseInt(hex[1] + hex[1], 16);
      g = parseInt(hex[2] + hex[2], 16);
      b = parseInt(hex[3] + hex[3], 16);
    } else if (hex.length === 7) {
      r = parseInt(hex[1] + hex[2], 16);
      g = parseInt(hex[3] + hex[4], 16);
      b = parseInt(hex[5] + hex[6], 16);
    } else {
      return null;
    }
    return (r * 299 + g * 587 + b * 114) / 1000;
  };

  const isDark = (hex) => {
    const brightness = getBrightness(hex);
    return brightness < 128;
  };

  const handleImageClick = (imagePath) => {
    setSelectedImage(imagePath);
  };

  const handlePdfClick = async (fileUrl, fileName) => {
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the blob URL
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // Fallback to the original method
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = fileName;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleOpenDialog = (fileId) => {
    setSelectedFileId(fileId);
    setDialogOpenAttachments(true);
  };

  const handleCloseDialog = () => {
    setSelectedFileId(null);
    setDialogOpenAttachments(false);
  };

  const saveDescription = async (description) => {
    try {
      await axios.put(`${backendIp}/api/board/ti/card_description`, {
        card_id: selectedCard.id,
        card_description: description,
        user: username,
        session_id: sessionId
      });
      fetchTiBoardData();
    } catch (error) {
      return null;
    }
  };

  const listArchives = async (cardId) => {
    try {
      const response = await axios.put(`${backendIp}/api/board/ti/list_archives`, {
        card_id: cardId,
        user: username,
        session_id: sessionId
      });
      return response.data;
    } catch (error) {
      return [];
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append('file', file);
    formData.append('user', username);
    formData.append('session_id', sessionId);

    try {
      const response = await axios.put(`${backendIp}/api/board/ti/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      const { file_id } = response.data;

      await axios.put(`${backendIp}/api/board/ti/save_attachment`, {
        card_id: selectedCard.id,
        file_id: file_id,
        file_name: file.name,
        name_complete: nameComplete,
        user: username,
        session_id: sessionId
      });

      const updatedAttachments = await listArchives(selectedCard.id);
      setAttachments(updatedAttachments);
      fetchLogs(selectedCard.id);
    } catch (error) {
      return null;
    }
  };

  const renderAttachments = (attachments) => {
    return attachments.map((attachment) => {
      const fileUrl = `${backendIp}/api/board/ti/get_image/${attachment.file_id}`;
      const fileExtension = attachment.file_name.split('.').pop().toLowerCase();

      // Adiciona suporte para download: pdf, kml, kmz, imagens
      const isDownloadable = ['pdf', 'kml', 'kmz', 'jpg', 'jpeg', 'png'].includes(fileExtension);

      // Função para baixar qualquer arquivo (inclusive imagem)
      const handleDownload = () => handlePdfClick(fileUrl, attachment.file_name);

      return (
        <div key={attachment.file_id} style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '10px', padding: '5px' }}>
          {isDownloadable ? (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                {/* Ícone para tipo de arquivo */}
                {['pdf', 'kml', 'kmz'].includes(fileExtension) ? (
                  <DescriptionIcon onClick={handleDownload} style={{ fontSize: '40px', cursor: 'pointer' }} />
                ) : (
                  <img
                    src={fileUrl}
                    alt={`anexo-${attachment.file_id}`}
                    style={{ width: '40px', height: '40px', cursor: 'pointer', borderRadius: '4px', objectFit: 'cover' }}
                    onClick={() => handleImageClick(fileUrl)}
                  />
                )}
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                  <p style={{ fontSize: '13px', margin: '0', padding: '0', fontWeight: '600' }}>
                    {attachment.file_name}
                  </p>
                  <div
                    style={{ marginTop: '2px', marginBottom: '2px', display: 'flex', justifyContent: 'flex-start' }}
                    onClick={handleDownload}
                  >
                    <DownloadIcon style={{ fontSize: '18px', color: '#009373', cursor: 'pointer' }} />
                  </div>
                </div>
              </div>
              <IconButton
                size='small'
                style={{ color: '#b52626', marginLeft: 'auto' }}
                onClick={() => handleOpenDialog(attachment.file_id)}
              >
                <DeleteRoundedIcon style={{ fontSize: '20px' }} />
              </IconButton>
            </>
          ) : (
            <>
              <img
                src={fileUrl}
                alt={`anexo-${attachment.file_id}`}
                style={{ width: '50px', height: '50px', cursor: 'pointer' }}
                onClick={() => handleImageClick(fileUrl)}
              />
              <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <p style={{ fontSize: '13px', margin: '0', padding: '0', fontWeight: '600' }}>
                  {attachment.file_name}
                </p>
              </div>
              <IconButton
                size='small'
                style={{ color: '#b52626' }}
                onClick={() => handleOpenDialog(attachment.file_id)}
              >
                <DeleteRoundedIcon style={{ fontSize: '20px' }} />
              </IconButton>
            </>
          )}
        </div>
      );
    });
  };

  const handleCloseModal = () => {
    saveCardDetails();
    closeModal();
    // Limpa cursores imediatamente ao fechar o modal
    setMousePositions({});
    setLastMouseUpdate({});
  };

  const handleCloseImage = () => {
    setSelectedImage(null);
  };

  const handleTitleChange = (newTitle) => {
    setCardDetails(prevDetails => ({
      ...prevDetails,
      title: newTitle
    }));

    axios.put(`${backendIp}/api/board/update_card_name`, {
      card_id: selectedCard.id,
      card_title: newTitle,
      user: username,
      session_id: sessionId
    })
      .then(response => {
        fetchTiBoardData();
      })
      .catch(error => {
        return null;
      });
  };

  const handleTaskAdded = () => {
    fetchTasks();
  };

  const handleAddItem = async () => {
    if (newItem.trim() !== '') {
      try {
        const response = await axios.put(`${backendIp}/api/board/ti/add_task`, {
          card_id: selectedCard.id,
          task_text: newItem,
          completed: false,
        });
        setItems([...items, { task_id: response.data.task_id, task_text: newItem, completed: false }]);
        setNewItem('');
        fetchTasks();
      } catch (error) {
        return null;
      }
    }
  };

  const fetchTasks = async () => {
    try {
      const response = await axios.put(`${backendIp}/api/board/ti/list_tasks`, {
        card_id: selectedCard.id,
        user: username,
        session_id: sessionId,
      });
      setItems(response.data);
    } catch (error) {
      return null;
    }
  };

  const handleAddLabel = async (color) => {
    try {
      await axios.put(`${backendIp}/api/board/ti/add_label`, {
        card_id: selectedCard.id,
        color_hex: color,
        user: username,
        session_id: sessionId
      });
      fetchTagsInCards();
    } catch (error) {
      return null;
    }
  };

  const handleMoveToArchive = async () => {
    try {
      await axios.put(`${backendIp}/api/board/ti/move_card_to_archive`, {
        card_id: selectedCard.id,
        board_id: boardId,
        name_complete: nameComplete,
        user: username,
        session_id: sessionId
      });

      // Atualiza os dados do quadro
      fetchTiBoardData();
      fetchLogs(selectedCard.id);

      // Fecha o modal
      handleCloseModal();
    } catch (error) {
      return null;
    }
  };

  const handleCompletedChange = (event) => {
    const newCompleted = event.target.checked;
    setCardDetails(prevDetails => ({
      ...prevDetails,
      completed: newCompleted
    }));

    axios.put(`${backendIp}/api/board/update_card_name`, {
      card_id: selectedCard.id,
      completed: newCompleted,
      user: username,
      session_id: sessionId
    })
      .then(response => {
        fetchTiBoardData();
      })
      .catch(error => {
        return null;
      });
  };

  // Função para clarear cor hex
  function lightenColor(hex, percent) {
    if (!hex || !hex.startsWith('#')) return hex;
    let r, g, b;
    if (hex.length === 4) {
      r = parseInt(hex[1] + hex[1], 16);
      g = parseInt(hex[2] + hex[2], 16);
      b = parseInt(hex[3] + hex[3], 16);
    } else if (hex.length === 7) {
      r = parseInt(hex[1] + hex[2], 16);
      g = parseInt(hex[3] + hex[4], 16);
      b = parseInt(hex[5] + hex[6], 16);
    } else {
      return hex;
    }
    r = Math.min(255, Math.floor(r + (255 - r) * percent));
    g = Math.min(255, Math.floor(g + (255 - g) * percent));
    b = Math.min(255, Math.floor(b + (255 - b) * percent));
    return `rgb(${r},${g},${b})`;
  }

  // Função para obter cor de fundo da capa (imagem ou cor sólida)
  const getCoverBackgroundColor = () => {
    const colorObj = coverColor.find(color => selectedCard && selectedCard.id === color.in_card_id);
    if (colorObj) return colorObj.hex_in_card;
    const imageObj = coverImage.find(image => selectedCard && selectedCard.id === image.card_id);
    if (imageObj) return 'rgba(0,0,0,0.45)';
    return '#ffffff';
  };

  // Função para obter cor de fundo da name-list (mais clara que a capa ou padrão)
  const getNameListBackground = () => {
    const colorObj = coverColor.find(color => selectedCard && selectedCard.id === color.in_card_id);
    if (colorObj) return lightenColor(colorObj.hex_in_card, 0.35); // 35% mais claro
    const imageObj = coverImage.find(image => selectedCard && selectedCard.id === image.card_id);
    if (imageObj) return 'rgba(255,255,255,0.25)'; // overlay mais claro
    // Se não houver capa, cor padrão
    return '#37471f';
  };

  // Função para decidir cor do texto da name-list
  const getNameListTextColor = () => {
    const colorObj = coverColor.find(color => selectedCard && selectedCard.id === color.in_card_id);
    const imageObj = coverImage.find(image => selectedCard && selectedCard.id === image.card_id);
    if (!colorObj && !imageObj) return '#cdeaa2'; // cor padrão se não houver capa
    const bgColor = getNameListBackground();
    if (bgColor.startsWith('rgba')) return '#172B4D';
    let r, g, b;
    if (bgColor.startsWith('rgb')) {
      [r, g, b] = bgColor.match(/\d+/g).map(Number);
    } else if (bgColor.startsWith('#')) {
      if (bgColor.length === 4) {
        r = parseInt(bgColor[1] + bgColor[1], 16);
        g = parseInt(bgColor[2] + bgColor[2], 16);
        b = parseInt(bgColor[3] + bgColor[3], 16);
      } else if (bgColor.length === 7) {
        r = parseInt(bgColor[1] + bgColor[2], 16);
        g = parseInt(bgColor[3] + bgColor[4], 16);
        b = parseInt(bgColor[5] + bgColor[6], 16);
      }
    }
    const brightness = typeof r !== 'undefined' ? (r * 299 + g * 587 + b * 114) / 1000 : 255;
    return brightness < 128 ? '#fff' : '#172B4D';
  };

  // Função para decidir cor do texto do header (igual ao name-list)
  const getHeaderTextColor = () => {
    const bgColor = getCoverBackgroundColor();
    if (bgColor.startsWith('rgba')) return '#fff';
    let r, g, b;
    if (bgColor.startsWith('rgb')) {
      [r, g, b] = bgColor.match(/\d+/g).map(Number);
    } else if (bgColor.startsWith('#')) {
      if (bgColor.length === 4) {
        r = parseInt(bgColor[1] + bgColor[1], 16);
        g = parseInt(bgColor[2] + bgColor[2], 16);
        b = parseInt(bgColor[3] + bgColor[3], 16);
      } else if (bgColor.length === 7) {
        r = parseInt(bgColor[1] + bgColor[2], 16);
        g = parseInt(bgColor[3] + bgColor[4], 16);
        b = parseInt(bgColor[5] + bgColor[6], 16);
      }
    }
    const brightness = typeof r !== 'undefined' ? (r * 299 + g * 587 + b * 114) / 1000 : 255;
    return brightness < 128 ? '#fff' : '#172B4D';
  };

  // Verifica se há capa (imagem ou cor) para o card selecionado
  const hasCover =
    (coverColor.some(color => selectedCard && selectedCard.id === color.in_card_id) ||
      coverImage.some(image => selectedCard && selectedCard.id === image.card_id));

  // Funções para exclusão de cartão
  const handleOpenDeleteCardDialog = () => {
    setDeleteCardDialogOpen(true);
  };

  const handleCloseDeleteCardDialog = () => {
    setDeleteCardDialogOpen(false);
  };

  const handleConfirmDeleteCard = async () => {
    try {
      await axios.put(`${backendIp}/api/board/ti/delete_card`, {
        card_id: selectedCard.id,
      });
      fetchTiBoardData();
      setDeleteCardDialogOpen(false);
      setAlert2({ message: 'Card excluído com sucesso!', severity: 'success' });
      setTimeout(() => {
        setAlert2(null);
      }, 3000);
      closeModal();
    } catch (error) {
      setAlert2({ message: 'Erro ao excluir card', severity: 'error' });
      setTimeout(() => {
        setAlert2(null);
      }, 3000);
      setDeleteCardDialogOpen(false);
    }
  };

  // Adicione esta função para atualizar o checklist
  const handleChecklistUpdate = () => {
    setTodos(true); // já força o Checklist2 a atualizar via useEffect
  };

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Detalhes do Card"
        className="card-modal"
        overlayClassName="card-modal-overlay"
        shouldCloseOnOverlayClick={true}
        ariaHideApp={false}
      >
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          {/* Renderiza capa de cor */}
          {coverColor.map((color) => (
            selectedCard != null &&
            selectedCard.id === color.in_card_id && (
              <Flex>
                <div
                  key={color.id}
                  style={{ backgroundColor: color.hex_in_card, width: '100%', height: '140px', position: 'relative', borderRadius: '10px 10px 0px 0px' }}
                ></div>
              </Flex>
            )
          ))}
          {/* Renderiza capa de imagem */}
          {coverImage.map((image) => (
            selectedCard != null &&
            selectedCard.id === image.card_id && (
              <Flex>
                <div
                  key={image.id}
                  style={{
                    backgroundImage: `url(${backendIp}/api/board/ti/get_image/${image.image_id})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    width: '100%',
                    height: '170px',
                    position: 'relative',
                    borderRadius: '10px 10px 0px 0px',
                  }}
                ></div>
              </Flex>
            )
          ))}
          {/* Header sobre a capa se existir */}
          <Flex
            className={`details-header1${hasCover ? ' overlay-header' : ''}`}
            style={hasCover ? { color: getHeaderTextColor() } : {}}
          >
            <div
              className='name-list'
              style={{
                background: getNameListBackground(),
                color: getNameListTextColor(),
              }}
            >
              <p style={{ fontSize: '12px', margin: '0px' }}>
                {selectedCard && selectedCard.list_name ? selectedCard.list_name : ''}
              </p>
            </div>
            <div className='buttons-header'>
              <MoveToInboxIcon
                style={{ cursor: 'pointer' }}
                onClick={handleMoveToArchive}
                title="Arquivar cartão"
              />
              <DeleteRoundedIcon className='delete-card' onClick={handleOpenDeleteCardDialog} />
              <CloseIcon
                style={{ cursor: 'pointer' }}
                onClick={handleCloseModal}
              />
            </div>
          </Flex>
          <Flex style={{ paddingBottom: '35px', paddingLeft: '35px', flex: 1, overflow: 'hidden' }}>
            <Div className='first-column'>
              <div className='sticky-card-header'>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  <Checkbox
                    {...label}
                    icon={<PanoramaFishEyeIcon />}
                    checkedIcon={<TaskAltIcon style={{ color: 'green' }} />}
                    checked={!!cardDetails.completed}
                    onChange={handleCompletedChange}
                    sx={{
                      padding: '8px 0px',
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                    }}
                  />
                  <EditableText text={cardDetails.title} onSave={handleTitleChange}></EditableText>
                </div>
              </div>
              <br></br>
              <div className='scrollable-content'>
                <div className='buttons-actions'>
                  <button
                    className='button-actions'
                    onClick={(event) => handleDetailClick(event, 'Checklist')}
                  >
                    <AddRoundedIcon style={{ fontSize: '20px' }} /> Checklist
                  </button>
                  <button
                    className='button-actions'
                    onClick={(event) => handleDetailClick(event, 'Copiar')}
                  >
                    <ContentCopyRoundedIcon style={{ fontSize: '17px' }} /> Copiar
                  </button>
                  <button
                    className='button-actions'
                    onClick={(event) => handleDetailClick(event, 'Capa')}
                  >
                    <AddRoundedIcon style={{ fontSize: '20px' }} /> Capa
                  </button>
                  <button
                    className='button-actions'
                    onClick={(event) => handleDetailClick(event, 'Compartilhar')}
                  >
                    <ShareRoundedIcon style={{ fontSize: '17px' }} /> Compartilhar
                  </button>
                </div>
                <Flex>
                  <div style={{ marginRight: '15px' }}>
                    <Span>Membros</Span>
                    <Flex style={{ marginTop: '10px', maxWidth: '205px', flexWrap: 'wrap' }}>
                      {usersInCards.map((user) => {
                        return (
                          selectedCard != null ?
                            selectedCard.id === user.user_card_id &&
                            <Avatar className='comment-avatar' src={getAvatarUrl(user.user_in_card)} /> : null
                        );
                      })}
                      <div className='button-open-membro' ><IconButton onClick={(event) => handleItemClick(event, 'Membros')}><AddIcon style={{ color: 'white', padding: '5px' }} /></IconButton>
                        {openDetail === 'Membros' && <Members
                          boardId={boardId}
                          fetchTiBoardData={fetchTiBoardData}
                          anchorEl={anchorEl2}
                          onClose={() => setOpenDetail(null)}
                          setSelectedCard={setSelectedCard}
                          selectedCard={selectedCard}
                          addUserToCardState={addUserToCardState}
                          fetchLogs={fetchLogs}
                        />}
                      </div>
                    </Flex>
                  </div>
                  <div>
                    <Span>Etiquetas</Span>
                    <Flex style={{ maxWidth: '410px', flexWrap: 'wrap' }}>
                      {tagsInCards.map((tag) => {
                        return (
                          selectedCard != null ?
                            selectedCard.id === tag.card_id &&
                            <div style={{ backgroundColor: tag.color_hex, minWidth: '60px', width: 'fit-content', height: '30px', marginTop: '10px', borderRadius: '5px', color: isDark(tag.color_hex) ? 'white' : 'black', fontSize: 13, fontWeight: 500, padding: '3px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{tag.tag_name}</div> : null
                        );
                      })}
                      <div className='button-open-etiqueta'><IconButton onClick={(event) => handleItemClick(event, 'Etiquetas')}><AddIcon style={{ color: 'white', padding: '3px' }} /></IconButton>
                        {openDetail === 'Etiquetas' && <Etiquetas
                          fetchTagsInCards={fetchTagsInCards}
                          handleSetSelectedTag={handleSetSelectedTag}
                          anchorEl={anchorEl2}
                          onClose={() => setOpenDetail(null)}
                        />}

                        {openDetail === 'Checklist' && (
                          <div className="action-modal-overlay" onClick={handleCloseDetail}>
                            <div className="action-modal-content" onClick={(e) => e.stopPropagation()}>
                              <Checklist
                                fetchLogs={fetchLogs}
                                handleSetNewTodos={handleNewTodos}
                                anchorEl={detailAnchorEl}
                                onClose={handleCloseDetail}
                                selectedCard={selectedCard}
                                fetchTiBoardData={fetchTiBoardData}
                              />
                            </div>
                          </div>
                        )}

                        {openDetail === 'Copiar' && (
                          <div className="action-modal-overlay" onClick={handleCloseDetail}>
                            <div className="action-modal-content" onClick={(e) => e.stopPropagation()}>
                              <CopyCard
                                addCard={addCard}
                                anchorEl={detailAnchorEl}
                                onClose={handleCloseDetail}
                                selectedCard={selectedCard}
                                handleCloseDetail={handleCloseDetail}
                                boardId={boardId}
                              />
                            </div>
                          </div>
                        )}

                        {openDetail === 'Capa' && (
                          <div className="action-modal-overlay" onClick={handleCloseDetail}>
                            <div className="action-modal-content" onClick={(e) => e.stopPropagation()}>
                              <Capa
                                anchorEl={detailAnchorEl}
                                onClose={handleCloseDetail}
                                selectedCard={selectedCard}
                                fetchCoverColor={fetchCoverColor}
                                fetchCoverImage={fetchCoverImage}
                              />
                            </div>
                          </div>
                        )}

                        {openDetail === 'Compartilhar' && (
                          <div className="action-modal-overlay" onClick={handleCloseDetail}>
                            <div className="action-modal-content" onClick={(e) => e.stopPropagation()}>
                              <Compartilhar
                                anchorEl={detailAnchorEl}
                                onClose={handleCloseDetail}
                                cardUrl={cardUrl}
                                selectedCard={selectedCard}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </Flex>
                  </div>
                </Flex>
                <Flex style={{ alignItems: 'center', marginBottom: '10px', marginTop: '55px' }}>
                  <PiListDashesFill style={{ fontSize: '25px' }} />
                  <Span style={{ fontSize: '15px' }}>Descrição</Span>
                </Flex>
                <div style={{ marginLeft: '15px' }}>
                  <EditableTextField
                    text={cardDetails.description}
                    onSave={(newText) => setCardDetails((prevDetails) => ({ ...prevDetails, description: newText }))}
                    renderAttachments={renderAttachments}
                    listArchives={listArchives}
                    fetchTiBoardData={fetchTiBoardData}
                    setAttachments={setAttachments}
                    saveDescription={saveDescription}
                    fetchLogs={fetchLogs}
                    multiline
                    rows={4}
                    placeholder={"Adicione uma descrição mais detalhada..."}
                    selectedCard={selectedCard}
                  />
                </div>
                <div style={{ marginBottom: '15px' }}>
                  <Flex style={{ marginBottom: '20px', justifyContent: 'space-between' }}>
                    <Flex style={{ alignItems: 'center' }}>
                      <TfiClip style={{ fontSize: '25px', }} />
                      <Span style={{ fontSize: '15px' }}>Anexos</Span>
                    </Flex>
                    {/* onClick={() => setIsEditing(true)}  */}
                    <div>
                      <Button component="label" htmlFor="file-upload" className='description-edit'>
                        Anexar
                      </Button>
                      <input
                        id="file-upload"
                        type="file"
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                      />
                    </div>
                  </Flex>
                  <div style={{ marginLeft: '15px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {renderAttachments(attachments)}
                  </div>
                  <ConfirmationDialog
                    open={dialogOpenAttachments}
                    onClose={handleCloseDialog}
                    onConfirm={handleConfirmDelete}
                    title="Confirmar Exclusão"
                    message="Tem certeza de que deseja excluir o anexo? Esta ação não pode ser desfeita."
                  />
                </div>
                <br></br>
                {selectedCard && (
                  <Checklist2
                    selectedCard={selectedCard}
                    onTaskAdded={handleTaskAdded}
                    newItem={newItem}
                    setNewItem={setNewItem}
                    handleAddItem={handleAddItem}
                    items={items}
                    setItems={setItems}
                    handleLogs={fetchLogs}
                    todos={todos}
                    setTodos={setTodos}
                    // Adicione esta prop:
                    onChecklistUpdate={handleChecklistUpdate}
                  />
                )}
              </div>
            </Div>
            <Div className='second-column'>
              <SideMenu
                boardId={boardId}
                listArchives={listArchives}
                setAttachments={setAttachments}
                handleSetSelectedTag={handleSetSelectedTag}
                setSelectedCard={setSelectedCard}
                selectedCard={selectedCard}
                addUserToCardState={addUserToCardState}
                setNewItem={setNewItem}
                fetchTasks={fetchTasks}
                handleAddItem={handleAddItem}
                fetchTiBoardData={fetchTiBoardData}
                fetchCoverColor={fetchCoverColor}
                fetchCoverImage={fetchCoverImage}
                handleNewTodos={handleNewTodos}
                fetchTagsInCards={fetchTagsInCards}
                fetchLogs={fetchLogs}
                addCard={addCard}
                cardUrl={cardUrl}
                setComments={setComments}
                comments={comments}
                logs={logs}
              />
            </Div>
          </Flex>
        </div>
        <Div style={{ width: 'calc(100% - 600px)', display: 'none' }}>
          <Typography variant="h6" style={{ marginTop: 20 }}>Etiquetas</Typography>
          <Box display="flex" marginBottom={2} flexDirection={'column'} gap={'5px'} >
            {['#FF5733', '#33FF57', '#3357FF', '#F333FF', '#FF33F3'].map(color => (
              <Button
                key={color}
                onClick={() => handleAddLabel(color)}
                style={{
                  backgroundColor: color,
                  minWidth: 40,
                  height: 40,
                  marginRight: 10
                }}
              />
            ))}
          </Box>
          <Box display="flex">
            {cardDetails.labels.map((label, idx) => (
              <Box
                key={idx}
                sx={{
                  width: 20,
                  height: 20,
                  backgroundColor: label,
                  marginRight: 1
                }}
              />
            ))}
          </Box>
        </Div>
      </Modal>
      {selectedImage && (
        <div onClick={handleCloseImage}
          style={{
            position: 'fixed',
            backgroundColor: 'rgba(0, 0, 0, 0.71)',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 3000,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          <img src={selectedImage} alt="selected" style={{ maxWidth: '50vw', maxHeight: '50vh' }} />
        </div>
      )}
      <ConfirmationDialog
        open={deleteCardDialogOpen}
        onClose={handleCloseDeleteCardDialog}
        onConfirm={handleConfirmDeleteCard}
        title="Confirmar Exclusão"
        message="Tem certeza que deseja excluir este cartão? Esta ação não pode ser desfeita."
      />
      {alert2 && <Alerts2 message={alert2.message} severity={alert2.severity} />}
      {renderMouseCursors()}
    </>
  );
}

export default CardModal;